var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KpisEnderecosExternosCards',{attrs:{"kpis":_vm.kpis,"loading":_vm.loading,"turnos":_vm.turnos}})
}
var staticRenderFns = []

export { render, staticRenderFns }